import React from "react";
import styles from "../styles/pages/about.module.css"

function Contact() {
    return (<div className={styles.about}>
About
    </div>);
}

export default Contact;